module.exports = "<div class=\"config-list-container container-fluid\">\n  <div class=\"rg-rules\"></div>\n  {{ getItemCountHelp(items) }}\n</div>\n";
